"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Study = void 0;
class Study {
    constructor(id, card) {
        this.id = id;
        this.card = card;
    }
    canShowProgrammeCard() {
        return !!this.card;
    }
    setProgrammeCard(card) {
        this.card = card;
    }
}
exports.Study = Study;
